export default __webpack_public_path__ + "static/10-64298db151c24bd167c87ac7170c97c9.png";